// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorizeAllManagementTable_floating_window__3F-bq {
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    right: 0;
    padding: 50px 20px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
}

.CategorizeAllManagementTable_custom_close_button__gbi-u {
    position: absolute;
    top: 5px;
    left: 5px;
}

.CategorizeAllManagementTable_custom_export_button__teBxG {
    position: absolute;
    top: 5px;
    left: 65px;
}

.CategorizeAllManagementTable_custom_update_button__piJoo {
    position: absolute;
    top: 5px;
    left: 205px;
}

.CategorizeAllManagementTable_custom_params_name__W0Z6W {
    position: absolute;
    right: 20px;
    top: 6px;
    padding: 10px;
    font-size: 24px;
    background-color: #e6e6e6;
}

.CategorizeAllManagementTable_floating_window_content__8a9Ge {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: #e6e6e6;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CategorizeAllManagementTable/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":[".floating_window {\n    position: absolute;\n    width: 50%;\n    height: 100%;\n    top: 0;\n    right: 0;\n    padding: 50px 20px;\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n}\n\n.custom_close_button {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n}\n\n.custom_export_button {\n    position: absolute;\n    top: 5px;\n    left: 65px;\n}\n\n.custom_update_button {\n    position: absolute;\n    top: 5px;\n    left: 205px;\n}\n\n.custom_params_name {\n    position: absolute;\n    right: 20px;\n    top: 6px;\n    padding: 10px;\n    font-size: 24px;\n    background-color: #e6e6e6;\n}\n\n.floating_window_content {\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    background-color: #e6e6e6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"floating_window": `CategorizeAllManagementTable_floating_window__3F-bq`,
	"custom_close_button": `CategorizeAllManagementTable_custom_close_button__gbi-u`,
	"custom_export_button": `CategorizeAllManagementTable_custom_export_button__teBxG`,
	"custom_update_button": `CategorizeAllManagementTable_custom_update_button__piJoo`,
	"custom_params_name": `CategorizeAllManagementTable_custom_params_name__W0Z6W`,
	"floating_window_content": `CategorizeAllManagementTable_floating_window_content__8a9Ge`
};
export default ___CSS_LOADER_EXPORT___;
